import { createAsyncThunk } from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import Config from '../../../Config';
import {clearHistory} from '../../../utilities/authentication/authenticationSlice';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import { initPage, goToPage, setShowAnnualInvoicePopup, setCallsDetailsPopUp, setInfoPopUP, setIsShowPopUp ,setPage, setOtpDetails, setGuidId, setSelectedBan,  } from './PersonalAreaInvoicesSlice';
import { openBase64ToPdfFile } from './helper/helper';
import helper from '../../../utilities/helper';
import authenticationProvider from '../../../utilities/authentication/authenticationProvider';
export const prepareInvoicesAsync = createAsyncThunk('personalAreaInvoicesPage/prepareInvoicesAsync', async (data, thunkAPI) => {
  try {

    if(data?.epiData){
      await thunkAPI.dispatch(initPage({epiData: data.epiData}));
    }

    const result = await thunkAPI.dispatch(checkInvoicePermissionAsync());
    const displayPage = result?.payload?.displayPage;

    switch (displayPage) {
      case 'OTP':
        thunkAPI.dispatch(setPage('otpVerifyCodePage'));
        break;
      case 'FullLogin':
        const isLoggedIn = thunkAPI.getState().authentication?.loginData?.isFullAuthenticated;
        if(isLoggedIn){
          thunkAPI.dispatch(clearHistory());
          await authenticationProvider.clearAuthenticationData();
        }
        const redirectUrl = location.pathname + location.search;
        authenticationProvider.redirectToLogin(redirectUrl, redirectUrl, '');
        break;
      case 'Invoice':
        thunkAPI.dispatch(setPage('invoicesPage'));
        await thunkAPI.dispatch(getInvoiceDataAsync());
        break;
    }

  } catch (error) {

  }
  finally {

  }
});

export const checkInvoicePermissionAsync = createAsyncThunk('personalAreaInvoicesPage/checkInvoicePermissionAsync', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());

    const state = thunkAPI.getState().personalAreaInvoicesPage;
    const otpTicketId = window.sessionStorage.getItem('otpTicketId');
    const sendTextAsVoice = !!data?.sendTextAsVoice;

    const params = {blockId : state.epiData.blockId, invoiceId: state.guidId, ticketId: otpTicketId, sendTextAsVoice: sendTextAsVoice };
    const result = await ProviderManager.getProviderData('checkInvoicePermission', params);

    return result?.Body;
  } catch (error) {
        const isLoggedIn = thunkAPI.getState().authentication?.loginData?.isFullAuthenticated;
        if(isLoggedIn){
          window.location.href = Config.lobbyUrl;
        }else{
          const redirectUrl = Config.lobbyUrl;
          authenticationProvider.redirectToLogin(redirectUrl, redirectUrl, '');
        }
  }
  finally {
      thunkAPI.dispatch(hideAppLoader());
  }
});

export const getInvoiceDataAsync  = createAsyncThunk('personalAreaInvoicesPage/getInvoiceDataAsync', async (data, thunkAPI) => {
  try {

    thunkAPI.dispatch(showAppLoader());
    var allInvoices = await thunkAPI.dispatch(getAllInvoicesAsync(data?.guidId));
    if(allInvoices.payload){
      await thunkAPI.dispatch(getFullMainAsync());
    }

  } catch (error) {

  }
  finally {
      thunkAPI.dispatch(hideAppLoader());
  }
});

export const getOtpDetailsByTicketAsync = createAsyncThunk('personalAreaInvoicesPage/getOtpDetailsByTicketAsync', async (data, thunkAPI) => {
  try {
    const params = { ticketId: data.ticketId };
    const result = await ProviderManager.getProviderData('getOtpDetailsByTicket', params);
    return result;
  } catch (error) {
    console.error('getOtpDetailsByTicketAsync', error);
  }
});

export const getMainInvoicesAsync = createAsyncThunk('personalAreaInvoicesPage/getMainInvoicesAsync', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getMainInvoices', data);
    return result?.Body;
  } catch (error) {
    console.error('getMainInvoicesAsync', error);
  }
});

export const getAllProductsAsync = createAsyncThunk('personalAreaInvoicesPage/getAllProductsAsync', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getAllProducts', data);
    return result?.Body;
  } catch (error) {
    console.error('getAllProductsAsync', error);
  }
});

export const getDetailsInvoicesAsync = createAsyncThunk('personalAreaInvoicesPage/getDetailsInvoicesAsync', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getDetailsInvoices', data);
    return result?.Body;
  } catch (error) {
    console.error('getDetailsInvoicesAsync', error);
  }
});

export const getInvoiceDataBySectionSubscriberNoAsync  = createAsyncThunk('personalAreaInvoicesPage/getInvoiceDataBySectionSubscriberNo', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getInvoiceDataBySectionSubscriberNo', data);
    return result?.Body;
  } catch (error) {
    console.error('getInvoiceDataBySectionSubscriberNoAsync', error);
  }
});

export const getCallsMainAsync  = createAsyncThunk('personalAreaInvoicesPage/getCallsMainAsync', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());

    const data =
    {
      invoiceId: "697B6649-54B0-A761-2270-1D7E9A22DC00",
    }

    const result = await ProviderManager.getProviderData('getCallsMain', data);
    return result?.Body;
  } catch (error) {
    console.error('getCallsMainAsync', error);
  }
});

export const getCallsListAsync  = createAsyncThunk('personalAreaInvoicesPage/getCallsListAsync', async (data, thunkAPI) => {
  try {

    thunkAPI.dispatch(showAppLoader());

    const selectedSubscriber = await thunkAPI.getState().personalAreaInvoicesPage.callsDetailsPage.selectedSubscriber;

    const data =
    {
      invoiceId: selectedSubscriber.invoiceId,
      subscriberNo: selectedSubscriber.subscriberNo,
      subSection: selectedSubscriber.subSection,
      sectionNo: selectedSubscriber.callSectionNo
    }

    const result = await ProviderManager.getProviderData('getCallsList', data);
    thunkAPI.dispatch(hideAppLoader());

      if(result?.Header.ReturnCode === 0){
        if(result?.Body.listCallListColumn?.length > 0){
        thunkAPI.dispatch(goToPage('callsDetailsPage_callsDetails'));
      }
        else{
        //TODO: show error message
      }
      }else{
      //TODO: show error message
    }

    return result?.Body;
  } catch (error) {
    console.error('getCallsList', error);
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const getAllInvoicesAsync = createAsyncThunk('personalAreaInvoicesPage/getAllInvoicesAsync', async (data, thunkAPI) => {
  try {
    //thunkAPI.dispatch(showAppLoader());
    let state = thunkAPI.getState().personalAreaInvoicesPage;
    const blockId = state.epiData.blockId;
    const guidId = data ? data : state.guidId;
    const otpTicketId = window.sessionStorage.getItem('otpTicketId');

    const invoiceData = {
      blockId : blockId,
      invoiceId: guidId,
      ticketId: otpTicketId
    };

    const result = await ProviderManager.getProviderData('getAllInvoices', invoiceData);

    return result?.Body;
  } catch (error) {
    console.error('getAllInvoicesAsync', error);
    if(error.status == 403){// TODO: handle 403 error - Forbidden
      thunkAPI.dispatch(prepareInvoicesAsync());
    }
  } finally {
    //thunkAPI.dispatch(hideAppLoader());
  }
});

export const getFullMainAsync = createAsyncThunk('personalAreaInvoicesPage/getFullMainAsync', async (data, thunkAPI) => {
  try {
    //thunkAPI.dispatch(showAppLoader());
    let state = thunkAPI.getState().personalAreaInvoicesPage;
    const blockId = state.epiData.blockId;
    const otpTicketId = window.sessionStorage.getItem('otpTicketId');

    const invoiceData = {
      blockId : blockId,
      invoiceId: state.guidId,
      ticketId: otpTicketId
    };

    let result = await ProviderManager.getProviderData('getFullMain', invoiceData);

    // const arrayTypeTal = result?.Body?.generalTab?.listDetailsData?.map(item => ({
    //   detailsId: item.detailsId,
    //   detailsType: item.detailsType
    // })) || [];
    // const listTypeProduct = [...new Set(arrayTypeTal.map(item => item.detailsType))];
    const allProductsResult = await thunkAPI.dispatch(getAllProductsAsync(invoiceData));
    //thunkAPI.dispatch(hideAppLoader());

    // result.Body.arrayTypeTal = arrayTypeTal;
    // result.Body.listTypeProduct = listTypeProduct;
    result.Body.allProducts = allProductsResult.payload;
    return result?.Body;
  } catch (error) {
    console.error('getFullMainAsync', error);
    return thunkAPI.rejectWithValue(error.message);
  } finally {
    //thunkAPI.dispatch(hideAppLoader());
  }
});

export const getCreditDataAsync = createAsyncThunk('personalAreaInvoicesPage/getCreditDataAsync', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    let state = thunkAPI.getState().personalAreaInvoicesPage;

    const invoiceData = {
      invoiceId: state.guidId
    };

    const result = await ProviderManager.getProviderData('getCreditData', invoiceData);
    return result?.Body;
  } catch (error) {
    console.error('getCreditDataAsync', error);
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const getHistoryPdfListAsync = createAsyncThunk('personalAreaInvoicesPage/getHistoryPdfListAsync', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getHistoryPdfList', data);
    return result?.Body;
  } catch (error) {
    console.error('getHistoryPdfListAsync', error);
  } finally {
  }
});

export const getCallsLogAuthAsync = createAsyncThunk('personalAreaInvoicesPage/getCallsLogAuthAsync', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    let state = thunkAPI.getState().personalAreaInvoicesPage;
    let userPhone = data?.userPhone;
    const subscriberNo =  userPhone?.replace("-", "");

    const request = {
      invoiceId: state.guidId,
      subscriberNo: subscriberNo
    }

    const result = await ProviderManager.getProviderData('getCallsLogAuth', request);
    thunkAPI.dispatch(hideAppLoader());
      if(result.Body){
        if(result.Body.logResponse.isCallLogExists){
            if(result.Body.logResponse.loginParam.isLoginPageView){
                thunkAPI.dispatch(goToPage('callsDetailsPage_login'));
            }
            else if(result.Body.logResponse.base64){
                openBase64ToPdfFile(result.Body?.logResponse?.base64);
            }
            else if(result.Body.logResponse.dalCallList.dalCallListPage.length == 0){
                thunkAPI.dispatch(setCallsDetailsPopUp({isDisplay: true , popupType: 'NoCallsDetails' }));
            }
            else if(result.Body.logResponse.dalCallList.dalCallListPage.length > 1){
                thunkAPI.dispatch(goToPage('callsDetailsPage_callType'));
            }
            else if(result.Body.logResponse.isCallLogExists){
                thunkAPI.dispatch(goToPage('callsDetailsPage_callsDetails'));
            }
        }else{
            thunkAPI.dispatch(setCallsDetailsPopUp({isDisplay: true , popupType: 'WithoutService' }));
        }
    }

    result.Body.subscriberNo = subscriberNo;
    return result?.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    console.error('getCallsLogAuthAsync', error);
  }
});

export const getCallsLogAuthCheckLoginAsync = createAsyncThunk('personalAreaInvoicesPage/getCallsLogAuthCheckLoginAsync', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    let state = thunkAPI.getState().personalAreaInvoicesPage;

    const request = {
      invoiceId: state.guidId,
      subscriberNo: state.callsDetailsPage.subscriberNo,
      userName: data.idNumber,
      additionalId: data.additionalIdNumber,
      userPassword: data.creditNumber4Digit,
      accountPassword: data.password,
      paypalEmail: data.paypalEmail
    }

    const result = await ProviderManager.getProviderData('getCallsLogAuthCheckLogin', request);
    thunkAPI.dispatch(hideAppLoader());
      if(result.Body){
        if(result.Body.logResponse.isLognSuccess){
        if(result.Body.logResponse.isCallLogExists){
            if(result.Body.logResponse.base64){
            openBase64ToPdfFile(result.Body?.logResponse?.base64);
            }
           else if(result.Body.logResponse.dalCallList.dalCallListPage.length == 0){
                thunkAPI.dispatch(setCallsDetailsPopUp({isDisplay: true , popupType: 'NoCallsDetails' }));
            }
            else if(result.Body.logResponse.dalCallList.dalCallListPage.length > 1){
                thunkAPI.dispatch(goToPage('callsDetailsPage_callType'));
            }
            else if(result.Body.logResponse.isCallLogExists){
                thunkAPI.dispatch(goToPage('callsDetailsPage_callsDetails'));
            }
        }else{
            thunkAPI.dispatch(setCallsDetailsPopUp({isDisplay: true , popupType: 'WithoutService' }));
        }
      }
    }

    return result?.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    console.error('getCallsLogAuthCheckLoginAsync', error);
  }
});

export const getPdfLogAuthAsync = createAsyncThunk('personalAreaInvoicesPage/getPdfLogAuthAsync', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    let state = thunkAPI.getState().personalAreaInvoicesPage;
    const doAccessibilityLayer = data?.isAccessibilityInvoice ? 1 : 0;
    const consolidationPdf = data?.isConsolidationPdf ? true : false;
    const invoiceId = data?.guidId ?? state.guidId;
    const systemSourcePDF = data?.systemSourcePDF;

    const request = {
      invoiceId: invoiceId,
      doAccessibilityLayer: doAccessibilityLayer,
      consolidationPdf: consolidationPdf,
      billingCycle: state.invoicesInfo?.main?.billingCycle ?? '',
      systemSourcePDF,
    }

    let result = await ProviderManager.getProviderData('getPdfLogAuth', request);
    thunkAPI.dispatch(hideAppLoader());
      if(result.Body){
      result.Body.doAccessibilityLayer = doAccessibilityLayer;
      result.Body.isConsolidationPdf = consolidationPdf;
      result.Body.systemSourcePDF = systemSourcePDF;

        if(result.Body.pdfResponse.status != 0){
        //TODO: SHOW ERROR MESSAGE
        }
        else if(!result.Body.pdfResponse.loginParam.isLoginPageView){
          if(!consolidationPdf){
            const base64 = result.Body?.pdfResponse?.base64;
            openBase64ToPdfFile(base64);
          }
      }
    }

    result.Body.invoiceId = invoiceId;
    return result?.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const getPdfAuthCheckLoginAsync = createAsyncThunk('personalAreaInvoicesPage/getPdfAuthCheckLoginAsync', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    let state = thunkAPI.getState().personalAreaInvoicesPage;
    const doAccessibilityLayer = state.identificationPopUp.doAccessibilityLayer;
    const consolidationPdf = state.identificationPopUp.isConsolidationPdf;
    const invoiceId = state.identificationPopUp.invoiceId;
    const systemSourcePDF = state.identificationPopUp.systemSourcePDF;
    const form = data.form;

    const request = {
      invoiceId: invoiceId,
      doAccessibilityLayer: doAccessibilityLayer,
      consolidationPdf: consolidationPdf,
      userName: form.idNumber,
      additionalId: form.additionalIdNumber,
      userPassword: form.creditNumber4Digit,
      accountPassword: form.password,
      paypalEmail: form.paypalEmail,
      systemSourcePDF,
    }

    let result = await ProviderManager.getProviderData('getPdfAuthCheckLogin', request);
    thunkAPI.dispatch(hideAppLoader());
    result.Body.isConsolidationPdf = consolidationPdf;

      if(result.Body?.logResponse.isLognSuccess){
        if(!consolidationPdf){
          const base64 = result.Body?.logResponse?.base64;
          openBase64ToPdfFile(base64);
        }
    }

    return result?.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    console.error('getPdfAuthCheckLoginAsync', error);
  }
});


export const getMeterParameterAsync = createAsyncThunk('personalAreaInvoicesPage/getMeterParameterAsync', async (data, thunkAPI) => {
  try {

    thunkAPI.dispatch(showAppLoader());
    const state = thunkAPI.getState().personalAreaInvoicesPage;
    const selectedBan = state.selectedBan

    const invoiceId = selectedBan.guidId;
    const cycleDate = selectedBan.cycle_date;
    const meterNumber =  data?.meterNumber ?? null;

    const invoiceData = {
      invoiceId: invoiceId,
      cycleDate: cycleDate,
      meterNumber: meterNumber
    };

    const result = await ProviderManager.getProviderData('getMeterParameter', invoiceData);
    thunkAPI.dispatch(hideAppLoader());

    if(result?.Header.ReturnCode === 0){
          const data = result?.Body;
          thunkAPI.dispatch(setInfoPopUP({data , title: 'נתוני מונה', type: 'METER_DETAILS'}));
          thunkAPI.dispatch(setIsShowPopUp(true));
    }

    return result?.Body;
  } catch (error) {
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

/*
export const createOtpAsync = createAsyncThunk('personalAreaInvoicesPage/createOtpAsync', async (data, thunkAPI) => {
  try {
    const contactNumber = data.contactNumber;

      let otpTicketId = '';
      const result = await ProviderManager.getProviderData('createOtp', [contactNumber, false]);

      if (result.Body && result.Body.step1Ticket) {
        otpTicketId = result.Body.step1Ticket;
        thunkAPI.dispatch(setOtpDetails({ otpTicketId: otpTicketId, otpPhone: contactNumber }));
        window.sessionStorage.setItem('otpTicketId', otpTicketId);
        return true;
      }

      return false;

  } catch (error) { }
});
*/

export const validateOtpAsync = createAsyncThunk('personalAreaInvoicesPage/validateOtpAsync', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const state = thunkAPI.getState().personalAreaInvoicesPage;

    const params = {
      invoiceId: state.guidId,
      ticketId: state.checkInvoicePermissionResult?.ticketId,
      otpCode: data.otpCode
    };
    const result = await ProviderManager.getProviderData('validateOtpInvoice', params);

    if (result?.Body?.isSuccess) {
      window.sessionStorage.setItem('otpTicketId', state.checkInvoicePermissionResult?.ticketId ?? '');
      thunkAPI.dispatch(setPage('invoicesPage'));
      await thunkAPI.dispatch(getInvoiceDataAsync());
      return true;
    }

    return false;

  } catch (error) {

  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const getEnergyBundleDetailsAsync = createAsyncThunk('personalAreaInvoicesPage/getEnergyBundleDetailsAsync', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const state = thunkAPI.getState().personalAreaInvoicesPage;

    const params = {
      invoiceId: state.guidId,
    };
    const result = await ProviderManager.getProviderData('getEnergyBundleDetails', params);

    if (result?.Body?.length > 0) {
      const details = result.Body[0];
      if(data == 'energyInvoice'){
        var energyInvoiceId = details.energy_guid_id;
        var ban = details.energy_ban;
        thunkAPI.dispatch(setGuidId(energyInvoiceId));
        thunkAPI.dispatch(setSelectedBan(ban));
        thunkAPI.dispatch(getInvoiceDataAsync({guidId: energyInvoiceId}));

      }


    }

  } catch (error) {

  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});
